import { Component, Input, SimpleChanges } from '@angular/core'
import * as _ from 'lodash'

@Component({
  selector: 'multi-select-search-option',
  template: require('./multi-select-search-option.component.html')
})

export class MultiSelectSearchOptionComponent {
  @Input() private option: Object
  @Input() private level: number
  @Input() private selectedValues: any
  @Input() private selectOptionFn: Function
  @Input() private deselectOptionFn: Function
  private selected: boolean = false

  ngOnInit() {
    if(this.option['value'] == 0) {
      window['xxx'] = this
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['option'] || changes['selectedValues']) {
      this.checkSelected()
    }
  }

  private toggleSelect(event) {
    if (this.selected) {
      this.deselectOptionFn(this.option)
    } else {
      this.selectOptionFn(this.option)
    }
  }

  private checkSelected() {
    this.selected = _.every(this.getSubtreeOptions(), (option) => {
      return this.selectedValues.indexOf(option['value']) > -1
    })
  }

  private getSubtreeOptions(option: Object = this.option, result: Object[] = []): Object[] {
    if(option['value'] !== null && option['value'] !== undefined) {
      result.push(option)
    }
    if(option['subOptions']) {
      for(let subOption of option['subOptions']) {
        this.getSubtreeOptions(subOption, result)
      }
    }
    return result
  }

  trackByFn(index, item) {
    return item["group"] ? 
      item["label"] : item["value"]
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/search/multi-select-search-option.component.ts